import TableComponent from "components/Table"
import { get } from "helpers/api_helper"
import React, { useEffect, useState } from "react"
import { Col, Row } from "reactstrap"
import axisCareReportListColumns from "./reportListColumns"
import { SaveButton } from "components/Buttons"
import Flatpickr from "react-flatpickr"

const AxisCareReports = ({
  downloadAxisCareReports,
  axisCareReports,
  getAxisCareReports,
}) => {
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [defaultOrder, setDefaultOrder] = useState({
    order: "first_name",
    direction: "asc",
  })

  const searchHanler = () => {
    getAxisCareReports({
      ...defaultOrder,
      page: 1,
      per_page: 15,
      ...(startDate.trim().length ? { start_date: startDate } : {}),
      ...(endDate.trim().length ? { end_date: endDate } : {}),
    })
    setShowResetButton(true)
  }

  const resetSearchHandler = () => {
    getAxisCareReports({
      ...defaultOrder,
      page: 1,
      per_page: 15,
    })
    setShowResetButton(false)
    setStartDate("")
    setEndDate("")
  }

  const handlePageChange = page => {
    getAxisCareReports({
      ...defaultOrder,
      page: page,
      per_page: 15,
      ...(startDate.trim().length ? { start_date: startDate } : {}),
      ...(endDate.trim().length ? { end_date: endDate } : {}),
    })
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getAxisCareReports({
      order: sortField,
      direction: sortOrder,
      page: 1,
      per_page: 15,
      ...(startDate.trim().length ? { start_date: startDate } : {}),
      ...(endDate.trim().length ? { end_date: endDate } : {}),
    })
    setDefaultOrder({ order: sortField, direction: sortOrder })
  }

  return (
    <React.Fragment>
      <Row className="mt-3">
        <Col>
          <h4>Exception Report</h4>
        </Col>
      </Row>
      <Row>
        <Col>
          <h6>
            The users on this report were NOT successfully imported due to a
            mismatched, invalid, missing, or duplicate email.
          </h6>
        </Col>
      </Row>
      <Row className={"my-2  d-flex justify-content-end"}>
        <Col xs="auto" className={"mb-2"}>
          {!!axisCareReports?.data?.length && (
            <SaveButton
              type="button"
              fullWidth={true}
              content="Download report"
              onClick={() =>
                downloadAxisCareReports({
                  download: true,
                  ...defaultOrder,
                  page: 1,
                  per_page: 15,
                  ...(startDate.trim().length ? { start_date: startDate } : {}),
                  ...(endDate.trim().length ? { end_date: endDate } : {}),
                })
              }
            />
          )}
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xs="auto" className="my-1">
          <Flatpickr
            className="form-control bg-white"
            placeholder="Start Date"
            options={{
              altInput: true,
              altFormat: "Y-m-d",
              dateFormat: "Y-m-d",
            }}
            value={startDate}
            onChange={(selectedDates, dateStr) => {
              setStartDate(dateStr)
            }}
          />
        </Col>
        <Col xs="auto" className="my-1">
          <Flatpickr
            className="form-control bg-white"
            placeholder="End Date"
            options={{
              altInput: true,
              altFormat: "Y-m-d",
              dateFormat: "Y-m-d",
            }}
            value={endDate}
            onChange={(selectedDates, dateStr) => {
              setEndDate(dateStr)
            }}
          />
        </Col>
        <Col xs="auto" className="my-1">
          <SaveButton type="button" content="Search" onClick={searchHanler} />
        </Col>
        {showResetButton && (
          <Col xs="auto" className="my-1">
            <SaveButton
              type="button"
              content="Reset"
              color="light"
              onClick={resetSearchHandler}
            />
          </Col>
        )}
      </Row>
      {axisCareReports ? (
        <React.Fragment>
          <Row className={"my-3"}>
            <Col>
              <TableComponent
                columns={axisCareReportListColumns()}
                data={axisCareReports?.data}
                paginationData={{
                  current_page: axisCareReports?.current_page,
                  last_page: axisCareReports?.last_page,
                  total_items: axisCareReports?.total,
                  items_per_page: axisCareReports?.per_page,
                  from: axisCareReports?.from,
                  to: axisCareReports?.to,
                  first_page: 1,
                }}
                onPageChange={handlePageChange}
                onTableSort={handleSort}
              />
            </Col>
          </Row>
        </React.Fragment>
      ) : (
        <Row className="d-flex justify-content-center mt-4">
          <Col xs="auto">
            <h6>No failed imports found</h6>
          </Col>
        </Row>
      )}
    </React.Fragment>
  )
}

export default AxisCareReports
